function CheckAnimado() {
  return (
    <svg className="check-animado" width="64" height="64" viewBox="0 0 54 54" aria-hidden="true">
      <circle cx="27" cy="27" r="24" />
      <path d="M16 28 L24 36 L39 19" />
    </svg>
  );
}

export default CheckAnimado;
